// export const baseURL =  "https://app.qrqr.work/";     // 本番環境（お名前ドットコム）
export const baseURL = "https://app-test.qrqr.work/";    // 検証環境（お名前ドットコム）
// export const baseURL = https://file.d2dship.com/";  // 本番環境（社内サーバ）
// export const baseURL = "http://172.16.100.127/";       // 検証環境（ローカル）
